import ProtectedRoute from "routes/ProtectedRoute";
import AdminLayout from "../../../components/UI/AdminLayout";
import { protectedRouteLoader } from "routes/loaders/protectedRouteLoader";

export const dashboardRoutes = [
  {
    path: "",
    loader: protectedRouteLoader,
    element: (
      <ProtectedRoute>
        <AdminLayout />
      </ProtectedRoute>
    ), // Parent route
    children: [
      {
        path: "overview",
        lazy: async () => {
          const mod = await import("../../../views/Admin/Dashboard/overview");
          const OverView = mod.OverView;
          return {
            Component: () => <OverView />,
          };
        },
      },
    ],
  },
];
